import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AdminapiService } from '../../shared/services/adminapi.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserInfo } from 'src/app/store/actions/user.action';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.states';

@Component({
  selector: 'app-adminsignup',
  templateUrl: './adminsignup.component.html',
  styleUrls: ['./adminsignup.component.scss']
})
export class AdminsignupComponent {

  formSubmitting=false;
  loginForm: FormGroup = this.fb.group({
    username: ['', [Validators.required]],
    email: ['', Validators.compose([Validators.required, Validators.email])],
    password: ['', Validators.compose([Validators.required, Validators.minLength(8)])],
  });

  constructor(private fb: FormBuilder,public adminApi: AdminapiService,private store: Store<AppState>, private toastrService: ToastrService, public router: Router) {}
  ngOnInit() {
  }

  onSigup(form: FormGroup) {
    if (form.valid && !this.formSubmitting) {
      this.formSubmitting=true;
      this.adminApi.signup(form.value).subscribe((data: any) => {
        if (data.success) {
          form.reset();
					this.toastrService.success(data.message);
          this.router.navigateByUrl('/admin/login');
        } else {
					this.toastrService.error(data.message);
        }
        this.formSubmitting=false;
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.formSubmitting=false;
      });
    } else {
      this.adminApi.validateAllFields(form);
    }
  }

  get f(): { [key: string]: AbstractControl } {
    return this.loginForm.controls;
  }

}
